import { RtCommodityShippedService } from './../../rt-commodity-shipped/rt-commodity-shipped.service';
import {
    TripCommentDialogData,
    RtTripCommentDialogComponent,
} from './../rt-trip-comment-dialog/rt-trip-comment-dialog.component';
import {
    Component,
    OnInit,
    OnChanges,
    Input,
    Output,
    EventEmitter,
    SimpleChanges,
    NgZone,
    ViewChild,
    ChangeDetectorRef,
} from '@angular/core';
import {
    RtTrip,
    RtTripUK,
    RtTripComment,
    RtTripAdapter,
    RtTripRefFieldDef,
    RtCommodityShipped,
    RtCommodityShippedUK,
    RtClmView,
} from '@bds/railtrac-models';
import { PopoutEvent } from '../../popout-event';
import {
    faSpinner,
    faInfo,
    faAddressBook,
    faFlaskPotion,
    faRoute,
    faLayerGroup,
    faWrench,
    faCodeBranch,
    faCommentAltLines,
    faEllipsisVAlt,
    faBars,
    faHandHoldingUsd,
    faFire,
    faExternalLink,
    faCheck,
    faExclamation,
    faClipboard,
    faHourglassHalf,
    faObjectGroup,
    faPlus,
} from '@fortawesome/pro-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/pro-duotone-svg-icons';
import { faTrain, faClmHistory, faSave } from '@bds/fa-svg-icons';
import { RailtracTripService } from '../railtrac-trip.service';
import { RtDiversionService } from './../../rt-diversion';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ScrollSpyService } from '@bds/helpers';
import { Observable, Subscription, defer, firstValueFrom, forkJoin, from, of } from 'rxjs';
import { catchError, finalize, map, mergeMap, switchMap, take, tap } from 'rxjs/operators';
import {
    EquipReportCategoryService,
    EquipReportCatgEquipService,
    EquipReportCatgValueService,
} from '@bds/equipment';
import {
    EquipmentReportCategoriesDialogOptions,
    EquipmentReportCategoriesDialogComponent,
} from '@bds/equipment';
import {
    Equipment,
    EquipReportCategory,
    EquipReportCatgEquip,
    EquipReportCatgValue,
} from '@bds/equipment';
import { RtCommodityShippedForm } from '../rt-commodity-shipped-form.service';
import { CommodityShippedService, RtTripCommentService } from '@bds/data-access';
import { ErrorHandlerService } from '@bds/railtrac-internal-services';
import { ErrorListItem, ErrorResultWithObject } from '@bds/rt-advance-models';
import { RailtracClmService } from '../../railtrac-clm/railtrac-clm.service';
import {
    RtMultiTripClmDialogComponent,
    TripClmDialogData,
} from '../rt-multi-trip-clm-dialog/rt-multi-trip-clm-dialog.component';
import {
    RtTripCommodityShippedDialogComponent,
    RtTripCommodityShippedDialogOptions,
} from '../rt-trip-commodity-shipped/rt-trip-commodity-shipped-dialog/rt-trip-commodity-shipped-dialog.component';

interface ISelectedTrip {
    id: number;
    key: RtTripUK;
    state: 'none' | 'pending' | 'saving' | 'saved' | 'failed';
    errors?: ErrorListItem[];
}

@Component({
    selector: 'rt-multi-trip',
    templateUrl: './rt-multi-trip.component.html',
    styleUrls: ['./rt-multi-trip.component.scss'],
    providers: [RtCommodityShippedForm],
})
export class RtMultiTripComponent implements OnInit, OnChanges {
    @Input() tripIds: number[];
    @Input() tripRefFieldDefs$: Observable<RtTripRefFieldDef[]>;
    @Input() allowPopout: boolean;
    @Input() isReadOnly = false;
    @Input() isOpenSeparateWindow = false;
    @Input() isUnitTrain = false;
    @Input() clearNoBillCLMEvent = false;
    @Output() popout: EventEmitter<PopoutEvent<number>> = new EventEmitter<PopoutEvent<number>>();

    currentHttpRequest: Subscription;
    combinedTrip: RtTrip;
    selectedTripKeys: RtTripUK[];
    selectedTrips: ISelectedTrip[];

    creatingDiversion = false;
    isReturnCityEditable = false;

    combinedCommShipped: RtCommodityShipped;
    selectedCommodityShippedKeys: RtCommodityShippedUK[] = [];

    equipCatItemsGroup: { [key: number]: EquipReportCatgEquip[] };
    equipCategoriesGroup: { [key: number]: EquipReportCategory };
    equipCatgValuesGroup: { [key: number]: EquipReportCatgValue };

    equipCatItems: EquipReportCatgEquip[];

    changes: Map<string, any> | any[] | any | undefined;
    commChanges: Map<string, any> | any[] | any | undefined;

    isDirty = false;
    isSaving = false;
    private readonly saveBatchSize = 10;
    private readonly saveConcurrency = 4;
    saveProgress = { completed: 0, total: 0 };

    get saveProgressPercent(): number {
        return this.saveProgress.total
            ? Math.round((this.saveProgress.completed / this.saveProgress.total) * 100)
            : 0;
    }

    iconSpinner = faSpinner;
    iconTrain = faTrain;
    iconDetail = faInfo;
    iconCustomer = faAddressBook;
    iconCommodity = faFlaskPotion;
    iconRoute = faRoute;
    iconAssignment = faLayerGroup;
    iconHistory = faClmHistory;
    iconProfile = faWrench;
    iconSave = faSave;
    iconComments = faCommentAltLines;
    iconVerticalEllipsis = faEllipsisVAlt;
    iconMenu = faBars;
    iconDetention = faHandHoldingUsd;
    iconDiversion = faCodeBranch;
    iconHotList = faFire;
    iconPopout = faExternalLink;
    iconGroup = faObjectGroup;
    iconAdd = faPlus;
    iconDelete = faTrashAlt;
    iconStatusSaved = faCheck;
    iconStatusSaving = faSpinner;
    iconStatusFailed = faExclamation;
    iconStatusNone = faClipboard;
    iconStatusPending = faHourglassHalf;

    @ViewChild('tripdiversionpanel') tripdiversionpanel: MatExpansionPanel;

    constructor(
        private tripService: RailtracTripService,
        private commodityShippedService: RtCommodityShippedService,
        private tripCommentService: RtTripCommentService,
        private equipReportCategoryService: EquipReportCategoryService,
        private equipReportCatgEquipService: EquipReportCatgEquipService,
        private equipReportCatgValueService: EquipReportCatgValueService,
        private adapter: RtTripAdapter,
        private _snackbar: MatSnackBar,
        public scrollSpyService: ScrollSpyService,
        public dialog: MatDialog,
        private zone: NgZone,
        private formService: RtCommodityShippedForm,
        public tripDiversionService: RtDiversionService,
        private errorHandler: ErrorHandlerService,
        private commodityService: CommodityShippedService,
        private clmService: RailtracClmService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        this.getCategories();
        this.getCategoryValues();
    }

    openMultiTripWindow(): void {
        if (this.tripIds && this.tripIds.length > 0) {
            const tripIdsString = this.tripIds.join(',');
            window.open(`/trips/multi?ids=${tripIdsString}&filter=true`, '_blank');
        }
    }

    //#region EquipmentCategory
    getCategories(): void {
        this.equipReportCategoryService
            .getAll()
            .pipe(take(1))
            .subscribe((res) => {
                const grp: { [key: number]: EquipReportCategory } = {};
                res.map((m) => {
                    grp[m.ormId] = m;
                });
                this.equipCategoriesGroup = grp;
            });
    }

    /**
     * Clears the CLM event for all selected trips.
     * @returns void
     */
    clearClmEvents(): void {
        if (!this.selectedTrips?.length) return;

        this.isSaving = true;

        let completedCount = 0;
        let successCount = 0;
        let failureCount = 0;

        this.selectedTrips.forEach((trip) => {
            const tripLabel = `${trip.key.carInit}${trip?.key?.carNo}`;

            this.clmService
                .getCurrentClm(trip.key.carInit, trip.key.carNo)
                .pipe(take(1))
                .subscribe({
                    next: (clm) => {
                        if (!clm) {
                            this._snackbar.open(
                                `No 'NO BILL' CLM event found for trip ${tripLabel}!`,
                                'Error',
                                { duration: 3000 },
                            );
                            failureCount++;
                            this.checkIfAllCompleted(++completedCount, successCount, failureCount);
                            return;
                        }

                        clm.clmEvent = null;
                        this.clmService
                            .updateClm(clm)
                            .pipe(take(1))
                            .subscribe({
                                next: () => {
                                    successCount++;
                                },
                                error: () => {
                                    this._snackbar.open(
                                        `Clear CLM Event Failed for trip ${tripLabel}!`,
                                        'Error',
                                        { duration: 3000 },
                                    );
                                    failureCount++;
                                },
                                complete: () => {
                                    this.checkIfAllCompleted(
                                        ++completedCount,
                                        successCount,
                                        failureCount,
                                    );
                                },
                            });
                    },
                    error: () => {
                        this._snackbar.open(
                            `Failed to fetch CLMs for trip ${tripLabel}!`,
                            'Error',
                            { duration: 3000 },
                        );
                        failureCount++;
                        this.checkIfAllCompleted(++completedCount, successCount, failureCount);
                    },
                });
        });
    }

    onAddProductClick(): void {
        const product = new RtCommodityShipped();

        const y: RtTripCommodityShippedDialogOptions = {
            product: product,
            productOp: 'add',
            multiTrip: true,
        };

        const dialogRef = this.dialog.open(RtTripCommodityShippedDialogComponent, {
            width: '800px',
            data: y,
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                // Create a copy of the result for each selected trip
                const requests: Observable<any>[] = [];

                this.selectedTrips.forEach((trip) => {
                    // Create a copy of the result for each trip
                    const tripProduct: RtCommodityShipped = { ...result };

                    // Update carInit and carNo for each trip
                    tripProduct.carInit = trip.key.carInit;
                    tripProduct.carNo = trip.key.carNo;
                    tripProduct.shipDate = trip.key.shipDatetime;
                    tripProduct.rtTripOrmId = trip.id;

                    // Add the request to the array
                    requests.push(this.commodityService.add(tripProduct));
                });

                // Execute all requests
                if (requests.length > 0) {
                    // Set all trips to saving state
                    this.selectedTrips.forEach((trip) => {
                        trip.state = 'saving';
                    });

                    forkJoin(requests).subscribe({
                        next: (responses) => {
                            // All succeeded
                            this.selectedTrips.forEach((trip) => {
                                trip.state = 'saved';
                            });
                            this._snackbar.open(
                                `Product saved for ${responses.length} trip(s).`,
                                'Ok',
                            );
                            this.loadSelectedCommodityShipped(this.tripIds);
                        },
                        error: (error) => {
                            // Handle partial or complete failure
                            this.selectedTrips.forEach((trip) => {
                                trip.state = 'failed';
                            });
                            this._snackbar.open('Error during save.', 'Error');
                            console.error('Error saving products:', error);
                        },
                    });
                }
            }
        });
    }

    private checkIfAllCompleted(completed: number, success: number, failure: number): void {
        if (completed === this.selectedTrips.length) {
            this.isSaving = false;

            if (failure === 0) {
                this._snackbar.open(`CLM Events cleared for all ${success} trip(s)!`, 'Ok', {
                    duration: 3000,
                });
                // this.change.emit(); // Optional
            }
        }
    }

    onDeleteProductClick(ormId: number): void {
        this.commodityService
            .delete(ormId)
            .pipe(take(1))
            .subscribe({
                next: () => {
                    this._snackbar.open('Product deleted.', 'Ok');
                    this.selectedCommodityShippedKeys = this.selectedCommodityShippedKeys.filter(
                        (data) => data.ormId !== ormId,
                    );
                },
                error: () => {
                    this._snackbar.open('Error during delete.', 'Ok');
                },
            });
    }

    getCategoryValues(): void {
        this.equipReportCatgValueService
            .getAll()
            .pipe(take(1))
            .subscribe((res) => {
                const grp: { [key: number]: EquipReportCatgValue } = {};
                res.map((m) => {
                    grp[m.ormId] = m;
                });
                this.equipCatgValuesGroup = grp;
            });
    }

    //#endregion EquipmentCategory

    addEquipmentCategory(): void {
        const data = new EquipmentReportCategoriesDialogOptions();
        data.beforeCloseAction = this.processEquipCatg;
        data.title = 'Assign Reporting Categories';
        data.item = this.equipCatItems;
        data.equipment = this.selectedTripKeys.map(
            (m) =>
                <Equipment>{
                    ormId: m.tcmEquipmentOrmId,
                    equipmentInit: m.carInit,
                    equipmentNo: m.carNo,
                },
        );
        const dialogRef = this.dialog.open(EquipmentReportCategoriesDialogComponent, {
            width: '850px',
            data: data,
        });

        dialogRef.afterClosed().subscribe(
            (result) => {
                if (!!result) {
                    this.fetchData();
                    this.zone.run(() => {
                        console.log('running zone defense');
                    });
                    this._snackbar.open('Reporting Categories saved successfully.');
                }
            },
            (error) => {
                this._snackbar.open('Error while saving Reporting Categories.');
            },
        );
    }

    //Get trip(s) data
    fetchData(
        isSave = false,
        preservedStates?: Map<number, Pick<ISelectedTrip, 'state' | 'errors'>>,
    ): void {
        this.tripService
            .readCombined(this.tripIds)
            .pipe(
                switchMap((combinedTripResult) =>
                    this.checkIfReturnCityEditable(this.tripIds).pipe(
                        map((isReturnCityEditable) => {
                            combinedTripResult.trip.isReturnCityEditable = isReturnCityEditable;
                            console.log(isReturnCityEditable);
                            return combinedTripResult;
                        }),
                    ),
                ),
                tap((combinedTripResult) => {
                    this.combinedTrip = combinedTripResult.trip;
                    this.selectedTrips = combinedTripResult.keys
                        .sort(this.carIdSort)
                        .map<ISelectedTrip>((data) => ({
                            id: data.ormId,
                            key: this.adapter.adapt(data),
                            state: preservedStates?.get(data.ormId)?.state ?? 'none',
                            errors: preservedStates?.get(data.ormId)?.errors,
                        }));
                    this.selectedTripKeys = combinedTripResult.keys.sort(this.carIdSort);
                    if (isSave) {
                        this.selectedTrips.forEach((item) => {
                            item.state = 'saved';
                        });
                    }
                    this.cdr.markForCheck();
                }),
                switchMap(() => this.checkIfReturnCityEditable(this.tripIds)),
                tap((isReturnCityEditable) => {
                    this.combinedTrip.isReturnCityEditable = isReturnCityEditable;
                    this.cdr.markForCheck();
                }),
                switchMap(() =>
                    this.tripService.getEquipReportCategories(
                        this.selectedTripKeys.map((m) => m.ormId),
                    ),
                ),
            )
            .subscribe((response) => {
                const s = response ?? [];
                const grp: { [key: number]: EquipReportCatgEquip[] } = {};
                s.map((m) => {
                    (grp[m.equipmentId] = grp[m.equipmentId] || []).push(m);
                });
                this.equipCatItemsGroup = grp;
                this.equipCatItems = s;

                this.cdr.markForCheck();
            });
    }

    onDiversionCreated(event: boolean): void {
        this.fetchData();
        this.onDiversionHide();
    }

    onDiversionHide(): void {
        if (this.tripdiversionpanel) {
            setTimeout(() => this.tripdiversionpanel.close());
        }
    }

    onDiversionPanelClosed(): void {
        this.creatingDiversion = false;
    }

    onDiversionPanelOpened(): void {
        this.creatingDiversion = true;
    }

    processEquipCatg = (item: EquipReportCatgEquip[]): boolean => {
        // 'ormId': new FormControl(eqCat.ormId, [ ]),
        // 'equipmentId': new FormControl(eqCat.equipmentId, [ ]),
        // 'equipReportCatgId': new FormControl(eqCat.equipReportCatgId, [ ]),
        // 'equipReportCatgValId': new FormControl(eqCat.equipReportCatgValId, [ Validators.required, Validators.min(1) ]),
        // 'effectDate': new FormControl(eqCat.effectDate, [ ]),
        // 'expireDate': new FormControl(eqCat.expireDate, [ ]),
        // 'lastModifiedUser': new FormControl(eqCat.lastModifiedUser, [ ]),
        // 'lastModifiedDatetime': new FormControl(eqCat.lastModifiedDatetime, [ ]),
        // '__status': new FormControl('', [ ]),
        item.forEach((eqCat) => {
            const status = (eqCat as any).__status;
            switch (status) {
                case 'Insert': {
                    eqCat.effectDate = this.selectedTripKeys.filter(
                        (f) => f.tcmEquipmentOrmId === eqCat.equipmentId,
                    )[0].shipDatetime;
                    this.equipReportCatgEquipService.create(eqCat).subscribe((s) => {
                        console.log('equipReportCatgEquipService.create.subscribe', s);
                    });
                    break;
                }
                case 'Delete': {
                    eqCat.expireDate = new Date();
                    this.equipReportCatgEquipService.update(eqCat.ormId, eqCat).subscribe((s) => {
                        console.log('equipReportCatgEquipService.update/delete.subscribe', s);
                    });
                    break;
                }
                case 'Update': {
                    this.equipReportCatgEquipService.update(eqCat.ormId, eqCat).subscribe((s) => {
                        console.log('equipReportCatgEquipService.update.subscribe', s);
                    });
                    break;
                }
            }
        });

        return true;
    };

    private carIdSort = (
        a: { carInit: string; carNo: string },
        b: { carInit: string; carNo: string },
    ) => {
        const nameA = `${(a.carInit + a.carNo).toUpperCase()}`;
        const nameB = `${(b.carInit + b.carNo).toUpperCase()}`;
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        // names must be equal
        return 0;
    };

    ngOnChanges(changes: SimpleChanges) {
        const tripIdChange = changes['tripIds'];
        if (!!tripIdChange) {
            const tripIdCurrent: number[] = tripIdChange.currentValue ?? [];
            this.combinedTrip = null;
            if (!tripIdCurrent.length) {
                this.selectedTrips = [];
                this.selectedTripKeys = [];
                this.combinedCommShipped = null;
                this.selectedCommodityShippedKeys = [];
                return;
            }
            this.fetchData();
            this.loadSelectedCommodityShipped(tripIdCurrent);
        }
    }

    loadSelectedCommodityShipped(tripIdCurrent: number[]): void {
        const tripIds = Array.isArray(tripIdCurrent) ? tripIdCurrent : [];
        if (!tripIds.length) {
            this.combinedCommShipped = null;
            this.selectedCommodityShippedKeys = [];
            return;
        }

        this.commodityShippedService.readCombined(tripIds).subscribe((s) => {
            this.combinedCommShipped = s.commoditiesShipped;
            this.selectedCommodityShippedKeys = s.keys?.sort(this.carIdSort) ?? [];
            this.cdr.markForCheck();
        });
    }

    checkIfReturnCityEditable(tripIds: number[]): Observable<boolean> {
        return this.tripService.isReturnCityEditable(tripIds);
    }

    addComment(): void {
        const dialogRef: MatDialogRef<RtTripCommentDialogComponent, RtTripComment[]> =
            this.dialog.open(RtTripCommentDialogComponent, {
                data: {
                    maxLength: 155,
                    tripUKs: this.selectedTripKeys,
                } as TripCommentDialogData,
                minWidth: 480,
            });
        dialogRef.afterClosed().subscribe((comments) => {
            if (comments) {
                const requests: Observable<RtTripComment>[] = [];
                comments.forEach((comment) => {
                    console.warn('MUST CHANGE RT_TRIP_COMMENT.SERVICE TO GET USER NAME!!!!');
                    comment.userId = 'shawnl';
                    requests.push(this.tripCommentService.create(comment));
                });

                forkJoin(requests).subscribe((s) => {
                    this._snackbar.open('Comments have been saved.');
                });
            }
        });
    }

    showTrip(ormId: number): void {
        console.log('showTrip clicked', ormId);
    }

    getTripErrorTooltip(trip: ISelectedTrip): string {
        return (trip.errors ?? [])
            .map((error) => error.errorMessage)
            .filter((message) => !!message)
            .join('\n');
    }

    getDirtyValues($event: Map<string, any> | any[] | any | undefined): void {
        // TODO: Make sure the Trip Refs 7 - 20 are in here
        this.changes = $event;
    }

    scroll(container: HTMLElement, component?: MatExpansionPanel): void {
        container.scrollIntoView({ behavior: 'smooth' } as ScrollIntoViewOptions);
        if (component instanceof MatExpansionPanel) {
            component.open();
        }
    }

    saveChanges(): void {
        if (this.isSaving) {
            return;
        }

        this.isSaving = true;

        // Only trips that are part of a save request are tracked and shown as saving.
        const tripStatuses = new Map<number, { success: boolean; errors: ErrorListItem[] }>();
        const queuedCounts = new Map<number, number>();
        const inFlightCounts = new Map<number, number>();
        const completedTrips = new Set<number>();
        this.saveProgress = { completed: 0, total: 0 };

        const updateProgress = (): void => {
            this.saveProgress = { completed: completedTrips.size, total: tripStatuses.size };
        };

        const markFailed = (tripId: number, errors: ErrorListItem[] = []): void => {
            const status = tripStatuses.get(tripId);
            if (status) {
                status.success = false;
                status.errors.push(...errors.map((val) => Object.assign({}, val)));
            }
        };

        const trackSaving = (tripIds: number[], task$: Observable<void>): Observable<void> => {
            tripIds.forEach((tripId) => {
                if (!tripStatuses.has(tripId)) {
                    tripStatuses.set(tripId, { success: true, errors: [] });
                }
                queuedCounts.set(tripId, (queuedCounts.get(tripId) ?? 0) + 1);
                const trip = this.selectedTrips.find((t) => t.id === tripId);
                if (trip && trip.state !== 'saving') {
                    trip.state = 'pending';
                    trip.errors = undefined;
                }
            });

            return defer(() => {
                tripIds.forEach((tripId) => {
                    queuedCounts.set(tripId, (queuedCounts.get(tripId) ?? 1) - 1);
                    inFlightCounts.set(tripId, (inFlightCounts.get(tripId) ?? 0) + 1);
                    completedTrips.delete(tripId);
                    const trip = this.selectedTrips.find((t) => t.id === tripId);
                    if (trip) {
                        trip.state = 'saving';
                        trip.errors = undefined;
                    }
                });
                updateProgress();
                this.cdr.markForCheck();
                return task$;
            }).pipe(
                finalize(() => {
                    tripIds.forEach((tripId) => {
                        const remaining = (inFlightCounts.get(tripId) ?? 1) - 1;
                        inFlightCounts.set(tripId, remaining);
                        if (remaining > 0) {
                            return;
                        }
                        const trip = this.selectedTrips.find((t) => t.id === tripId);
                        if ((queuedCounts.get(tripId) ?? 0) > 0) {
                            // Still has another batch waiting (e.g. its commodities).
                            if (trip) {
                                trip.state = 'pending';
                            }
                            return;
                        }
                        completedTrips.add(tripId);
                        const status = tripStatuses.get(tripId);
                        if (trip && status) {
                            trip.state = status.success ? 'saved' : 'failed';
                            trip.errors = status.errors.length ? status.errors : undefined;
                        }
                    });
                    updateProgress();
                    this.cdr.markForCheck();
                }),
            );
        };

        const tasks: Observable<void>[] = [
            ...this.createTripSaveTasks(markFailed, trackSaving),
            ...this.createCommoditySaveTasks(markFailed, trackSaving),
        ];

        if (!tasks.length) {
            this.isSaving = false;
            this._snackbar.open('No changes to save.', 'Ok', { duration: 3000 });
            return;
        }

        updateProgress();

        from(tasks)
            .pipe(
                mergeMap((task$) => task$, this.saveConcurrency),
                finalize(() => {
                    this.isSaving = false;
                    this.cdr.markForCheck();
                }),
            )
            .subscribe({
                // Runs once, only after every batch request has finished.
                complete: () => this.onAllSavesCompleted(tripStatuses),
            });
    }

    private onAllSavesCompleted(
        tripStatuses: Map<number, { success: boolean; errors: ErrorListItem[] }>,
    ): void {
        let successCount = 0;
        let failedCount = 0;
        const preservedStates = new Map<number, Pick<ISelectedTrip, 'state' | 'errors'>>();

        tripStatuses.forEach((status, tripId) => {
            if (status.success) {
                successCount++;
            } else {
                failedCount++;
            }
            preservedStates.set(tripId, {
                state: status.success ? 'saved' : 'failed',
                errors: status.errors.length ? status.errors : undefined,
            });
        });

        // Keep the form dirty when any batch failed so unsaved changes aren't silently discarded.
        this.isDirty = failedCount > 0;

        this._snackbar.open(
            failedCount > 0 ? `Save failed for ${failedCount} trip(s).` : 'Save succeeded.',
            'Ok',
        );

        if (failedCount === 0) {
            this.loadSelectedCommodityShipped(this.tripIds);
            this.fetchData(false, preservedStates);
        }
    }

    private createTripSaveTasks(
        markFailed: (tripId: number, errors?: ErrorListItem[]) => void,
        trackSaving: (tripIds: number[], task$: Observable<void>) => Observable<void>,
    ): Observable<void>[] {
        if (!this.changes) {
            return [];
        }

        const changes = this.changes;
        return this.chunk(
            this.selectedTrips.map((m) => m.id),
            this.saveBatchSize,
        ).map((batchIds) =>
            trackSaving(
                batchIds,
                this.tripService.setCombined(batchIds, changes).pipe(
                    map((response: any[]) => {
                        batchIds.forEach((tripId) => {
                            const status = response?.find((i) => i.key === tripId)?.value;
                            if (status && !status.succeeded) {
                                const errors: ErrorListItem[] = [];
                                const errorObject: ErrorResultWithObject = {
                                    bourqueDataResult: status,
                                    relatedObject: null,
                                };
                                //Parsing for any other errors generated by DB triggers
                                this.errorHandler.parseResultWithObject(errorObject).subscribe({
                                    error: (err) => {
                                        err.forEach((val) => errors.push(val));
                                    },
                                });
                                markFailed(tripId, errors);
                            }
                        });
                    }),
                    catchError(() => {
                        batchIds.forEach((tripId) => markFailed(tripId));
                        return of(undefined);
                    }),
                ),
            ),
        );
    }

    private createCommoditySaveTasks(
        markFailed: (tripId: number, errors?: ErrorListItem[]) => void,
        trackSaving: (tripIds: number[], task$: Observable<void>) => Observable<void>,
    ): Observable<void>[] {
        const uniqueChanges = this.formService.getCommodityShippedUniqueFormChanges(
            this.selectedCommodityShippedKeys ?? [],
        );
        const getTripId = (commodityOrmId: number): number | undefined =>
            this.selectedCommodityShippedKeys?.find((x) => x.ormId === commodityOrmId)?.rtTripOrmId;

        return this.chunk(uniqueChanges, this.saveBatchSize).map((batch) => {
            const batchTripIds = Array.from(
                new Set(
                    batch
                        .map((change) => getTripId(change.key.ormId))
                        .filter((id): id is number => id !== undefined),
                ),
            );

            return trackSaving(
                batchTripIds,
                forkJoin(
                    batch.map((change) => {
                        const commodityOrmId = change.key.ormId;
                        const tripId = getTripId(commodityOrmId);

                        return this.commodityShippedService
                            .setCombined([commodityOrmId], change.changes)
                            .pipe(
                                map((response) => {
                                    const status = response?.[commodityOrmId];
                                    if (status && !status.succeeded && tripId !== undefined) {
                                        markFailed(tripId);
                                    }
                                }),
                                catchError(() => {
                                    if (tripId !== undefined) {
                                        markFailed(tripId);
                                    }
                                    return of(undefined);
                                }),
                            );
                    }),
                ).pipe(map(() => undefined)),
            );
        });
    }

    private chunk<T>(items: T[], size: number): T[][] {
        const result: T[][] = [];
        for (let i = 0; i < items.length; i += size) {
            result.push(items.slice(i, i + size));
        }
        return result;
    }

    async reApplyClms(): Promise<void> {
        const result = await firstValueFrom(this.clmService.bulkReapplyClms(this.tripIds));

        if (result) {
            if (result.succeeded) {
                this.combinedTrip = null;
                this.fetchData();
                this.loadSelectedCommodityShipped(this.tripIds);
                this._snackbar.open('CLMs Reapplied!', 'Ok', {
                    duration: 3000,
                });
                return;
            }

            this._snackbar.open(result.errors[0].defaultDescription, 'Error', {
                duration: 3000,
            });
        }
    }

    addClmsDialog(): void {
        const clms = this.selectedTripKeys.map(({ carInit, carNo }) => {
            return { carInit, carNo };
        }) as RtClmView[];

        const dialogRef: MatDialogRef<RtMultiTripClmDialogComponent, TripClmDialogData> =
            this.dialog.open(RtMultiTripClmDialogComponent, {
                data: {
                    clms,
                } as TripClmDialogData,
                minWidth: 1000,
            });
        dialogRef.afterClosed().subscribe((clms) => {
            if (clms) {
                const requests: Observable<TripClmDialogData>[] = [];
                forkJoin(requests).subscribe((s) => {
                    this._snackbar.open('CLMs have been saved.');
                });
            }
        });
    }
}
